function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';
import PropTypes from '../../_snowpack/pkg/prop-types.js';

function SvgComponent({
  color,
  height,
  size,
  width,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: width || size,
    height: height || size
  }, rest), /*#__PURE__*/React.createElement("rect", {
    x: "0.35",
    y: "6.35",
    width: "14.3",
    height: "3.3",
    rx: "1.65",
    fill: "#DAF0ED",
    stroke: "#828A90",
    strokeWidth: "0.7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0.35",
    y: "0.35",
    width: "14.3",
    height: "3.3",
    rx: "1.65",
    fill: "#DAF0ED",
    stroke: "#828A90",
    strokeWidth: "0.7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0.35",
    y: "12.35",
    width: "14.3",
    height: "3.3",
    rx: "1.65",
    fill: "#DAF0ED",
    stroke: "#828A90",
    strokeWidth: "0.7"
  }));
}

SvgComponent.defaultProps = {
  size: 15
};
SvgComponent.propTypes = {
  height: PropTypes.number,
  size: PropTypes.number,
  width: PropTypes.number
};
export default SvgComponent;